<template>
    <div class="container">
        <HeaderPromo class="container-ignore"></HeaderPromo>
        <div class="header">
            <div class="header__left" v-if="!$device.isDesktop">
                <nuxt-link to="/" class="link-back">
                    <svg-icon name="arrow-left--18" width="18" height="18" />
                </nuxt-link>
            </div>
            <div class="header__logo">
                <nuxt-link to="/">
                    <img v-lazy-load data-src="/img/logo.svg" alt="" />
                </nuxt-link>
            </div>
            <div class="header__right text_11">
                <nuxt-link v-if="$device.isDesktop" to="/" class="link-back">
                    <svg-icon name="arrow-left" width="16" height="16" />
                    {{ $t("back_to_shop") }}
                </nuxt-link>
                <span class="header__lk" v-if="!$device.isMobile">
                    <nuxt-link :to="$auth.loggedIn ? '/lk' : '/lk/login/?redirect=zakaz'" class="flex-c">
                        <svg-icon name="user" width="32" height="32"></svg-icon>
                        <span>{{ $auth.loggedIn ? $auth.user.name : $i18n.t("войти") }}</span>
                    </nuxt-link>
                    <transition name="fade">
                        <div class="header__auth-message color-text_2" v-if="showWarn">
                            <div>{{ $t("авторизуйтесь") }}</div>
                            <div>{{ $t("header_auth_message") }}</div>
                            <div class="flex">
                                <nuxt-link class="color-text_1" to="/lk/login/?redirect=zakaz">{{
                                    $t("войти")
                                }}</nuxt-link>
                                <span class="like-link" @click="showWarn = false">{{ $t("close") }}</span>
                            </div>
                        </div>
                    </transition>
                </span>
                <div class="header__links-toggler" v-if="!$device.isDesktop" @click="isShowLinks = !isShowLinks">
                    {{ $t("help") }}
                </div>
                <transition name="fade">
                    <div class="header__links" v-bsl="isShowLinks && !$device.isDesktop" v-if="isShowLinks">
                        <SocialLinks type="messenger" :customClass="!$device.isDesktop ? 'social--vertical' : ''" />
                        <div
                            class="header__links-phone"
                            v-if="
                                $store.getters['globalvars/getShowContactPhone'] &&
                                $store.getters['globalvars/getLang'] &&
                                $store.getters['globalvars/getLang'] === 'ru'
                            ">
                            <a :href="'tel:' + $store.getters['globalvars/getContactPhone']">{{
                                $store.getters["globalvars/getContactPhone"]
                            }}</a>
                            <span class="color-text_3 work-time">09:00 - 21:00</span>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div
                        class="header__links-dimmer"
                        v-bsl="isShowLinks && !$device.isDesktop"
                        v-if="isShowLinks && !$device.isDesktop"
                        @click="isShowLinks = false"></div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
import SocialLinks from "~/components/SocialLinks";
import HeaderPromo from "./HeaderPromo.vue";
export default {
    name: "HeaderOrder",
    components: { SocialLinks, HeaderPromo },
    data() {
        return {
            isShowLinks: this.$device.isDesktop,
            showWarn: false,
        };
    },
    watch: {
        $route() {
            this.checkRoute();
        },
    },
    methods: {
        checkRoute() {
            if (!this.$auth.loggedIn && this.$route.path.indexOf("/zakaz") >= 0) {
                this.showWarn = true;
            } else {
                this.showWarn = false;
            }
        },
    },
    mounted() {
        this.checkRoute();
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 5;
    background: @bg;
    @media @sm {
        z-index: 8;
    }
}
.work-time {
    margin-left: 8px;
}

.header {
    z-index: 1;
    display: flex;
    align-items: center;
    margin: 0 -32px;
    padding: 0 32px;
    justify-content: space-between;
    border-bottom: 1px solid @border2;
    .trs(box-shadow);

    @media @sm {
        margin: 0 -16px;
        padding: 0 16px;
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
    }
    // @media @notsm {
    //     &:after {
    //         content: "";
    //         display: block;
    //         position: absolute;
    //         bottom: -36px;
    //         height: 1px;
    //         background: @border2;
    //         left: 0;
    //         right: 0;
    //     }
    // }

    &__logo {
        svg {
            display: block;
        }
    }
    &__right {
        display: flex;
        align-items: center;
        @media @sm {
            justify-content: flex-end;
        }
        .is_apple {
            padding-top: 1px;
        }
        a {
            display: flex;
            align-items: center;
            svg {
                margin-right: 8px;
            }
            + a {
                margin-left: 32px;
            }
        }
    }
    &__links {
        display: flex;
        align-items: center;
        margin-left: 32px;
        @media @sm {
            position: absolute;
            margin-left: 0;
            top: 36px;
            z-index: 2;
            left: 0;
            right: 0;
            background: @bg;
            padding: 24px;
            text-align: center;
            flex-direction: column;
            border-top: 1px solid @border2;
        }
    }
    &__links-phone {
        display: flex;
        margin-left: 32px;
        @media @sm {
            margin-left: 0;
            margin-top: 24px;
        }
    }
    &__links-dimmer {
        position: absolute;
        z-index: 1;
        top: 36px;
        left: 0;
        right: 0;
        height: calc(100dvh - 36px);
        background: rgba(242, 241, 233, 0.7);
    }
    &__links-toggler {
        margin-left: 24px;
    }
    &__lk {
        position: relative;
        margin-left: 32px;
        svg {
            margin-right: 0 !important;
        }
    }
    &__auth-message {
        position: absolute;
        z-index: 1;
        margin-top: 2px;
        top: 100%;
        left: 0;
        padding: 16px;
        background: #fff;
        border: 1px @border2 solid;
        div + div {
            margin-top: 8px;
            + div {
                margin-top: 16px;
            }
        }
        .flex {
            gap: 24px;
            a,
            span {
                text-decoration: underline;
            }
        }
    }
}
</style>
